import React, { useState } from 'react';
import { CategoryData } from './data';
import {Link } from 'react-router-dom';



export default function ProductCategory() {
  const [activeTab, setActiveTab] = useState(CategoryData[0].id);

    return (
    <>
    <div className="page-title light-background">
      <div className="container d-lg-flex justify-content-between align-items-center">
        {/* <h1 className="mb-2 mb-lg-0">Product Category</h1> */}
        <nav className="breadcrumbs">
          <ol>
            <li><Link to="/">Home</Link></li>
            <li className="current">Product Category</li>
          </ol>
        </nav>
      </div>
    </div>
    <section id="features" className="features section">
      <div className="container section-title aos-init aos-animate" data-aos="fade-up">
        <h2>Product</h2>
        <p>Category<br /></p>
      </div>

      <div className="container aos-init aos-animate" data-aos="fade-up" data-aos-delay="100">
        <div className="row">
          {/* Tab Navs */}
          <div className="col-lg-3">
            <ul className="nav nav-tabs flex-column" role="tablist">
              {CategoryData.map((tab) => (
                <li className="nav-item" role="presentation" key={tab.id}>
                  <button
                    className={`nav-link ${activeTab === tab.id ? 'active show' : ''}`}
                    onClick={() => setActiveTab(tab.id)}
                    type="button"
                    role="tab"
                  >
                    {tab.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Tab Content */}
            <div className="col-lg-9 mt-4 mt-lg-0">
            <div className="tab-content rw-tab">
            <div className="row">
                {CategoryData.find(tab => tab.id === activeTab)?.products.map((product, index) => (
                    <div key={`${product.modelId}-${index}`} className="col-6 col-md-3 mb-4">
                    <div className="border rounded text-center h-100">
                        <img
                        src={product.image}
                        alt={product.modelId}
                        className="img-fluid "
                        style={{ width: '120px', height: '150px', objectFit: 'cover' }}
                        />
                        <div className="model-name text-white fw-bold py-1">{product.modelId}</div>
                        <div className="text-muted small mt-1">
                        {product.name && (<p className="mb-1"><b>Name:</b> {product.name}</p>)}
                        {product.weight && (<p className="mb-1"><b>Weight:</b> {product.weight}</p>)}
                        {product.weight && (<p className="mb-1"><b>Length:</b> {product.weight}</p>)}
                        {product.size && (<p className="mb-1"><b>Size:</b> {product.size}</p>)}
                        </div>
                    </div>
                    </div>
                ))}
                </div>
            </div>
            </div>
        </div>
      </div>
    </section>
    </>
  );
}